import { useState } from 'react'
import adminApi from '../adminApi'
import './AdminForm.css'

export default function AdminForm({ apiKey, onLoginSuccess }) {
    const [login, setLogin] = useState('')
    const [password, setPassword] = useState('')
    const [isSending, setIsSending] = useState(false)
    const [error, setError] = useState('')

    const isDisabled = login.trim() === '' || password.trim() === '' || isSending

    const submitForm = async (e) => {
        e.preventDefault()
        if (isDisabled) return

        setIsSending(true)
        setError('')

        try {
            await adminApi.post(
                apiKey + '/login',
                {
                    login: login.trim(),
                    password,
                },
                {
                    skipAuthRefresh: true,
                }
            )

            onLoginSuccess?.()
        } catch {
            setError('Логин или пароль не подошли. Проверьте данные и попробуйте ещё раз.')
        } finally {
            setIsSending(false)
        }
    }

    return (
        <section className="adminLogin">
            <div className="adminLogin__badge">Neurosfera admin</div>
            <h1>Вход в панель</h1>
            <p className="adminLogin__lead">
                Авторизуйтесь, чтобы управлять продуктами, фичами и настройками калькулятора.
            </p>

            <form onSubmit={submitForm} className="adminLogin__form">
                <label className="adminLogin__field">
                    <span>Логин</span>
                    <input
                        type="text"
                        value={login}
                        onChange={(event) => setLogin(event.target.value)}
                        autoComplete="username"
                        placeholder="Введите логин"
                        disabled={isSending}
                    />
                </label>

                <label className="adminLogin__field">
                    <span>Пароль</span>
                    <input
                        type="password"
                        value={password}
                        onChange={(event) => setPassword(event.target.value)}
                        autoComplete="current-password"
                        placeholder="Введите пароль"
                        disabled={isSending}
                    />
                </label>

                {error && <p className="adminLogin__error">{error}</p>}

                <button className="adminLogin__submit" type="submit" disabled={isDisabled}>
                    {isSending ? 'Входим...' : 'Войти'}
                </button>
            </form>
        </section>
    )
}
